<script setup lang="ts">
/**
 * The Dometry logotype at the top of the navigation, linking to the current
 * organization's home. It narrows to the mark when the sidebar collapses;
 * `compact` shows the mark alone (phone top bar).
 */
import { computed } from 'vue';
import DLogo from '../../design/components/DLogo.vue';
import { useWorkspaceStore } from '../../app/stores/workspace.ts';

defineProps<{ compact?: boolean }>();
defineEmits<{ navigate: [] }>();
const workspace = useWorkspaceStore();
const home = computed(() =>
  workspace.currentSlug ? { name: 'org', params: { org: workspace.currentSlug } } : '/',
);
</script>

<template>
  <RouterLink
    :to="home"
    class="brand-bar"
    :class="{ 'brand-bar--compact': compact }"
    aria-label="Dometry"
    @click="$emit('navigate')"
  >
    <DLogo :full="!compact" />
  </RouterLink>
</template>
